import React from "react";
import styles from './Branches.module.css'; 
import { useNavigate } from "react-router-dom";

const BranchCard = ({ id, cityName, branchName, photo, branch }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    console.log("his data", branch); // Logs the branch data when the card is clicked
    console.log("his data", branch?.brn_num); // Logs the branch data when the card is clicked
    localStorage.setItem("branchId", branch?.brn_num);
    navigate(`/HomePage`);    
  };

  return (
    <div className={styles.cardContainer} onClick={handleCardClick} style={{cursor:"pointer"}} >
      <img src={photo} alt="Branch" className={styles.cardImage} />
      <div className={styles.cardContent}>
        <h3 className={styles.cityName}>{cityName}</h3>
        <p className={styles.branchName}>{branchName}</p>
      </div>
    </div>
  );
};

export default BranchCard;
